export const IMAGES = {
  coachPortrait:
    'https://customer-assets-cm19k8pv.emergentagent.net/job_work-alignment/artifacts/x6i42j6s_WhatsApp%20Image%202026-06-15%20at%2014.56.06.webp',
  coachAbout:
    'https://customer-assets-cm19k8pv.emergentagent.net/job_work-alignment/artifacts/81056a29e377549d_WhatsApp%20Image%202026-10-17%20at%2014.45.37%20%281%29.jpeg',
};

// Les 5 étapes de la méthode Clarté & Contrôle (métaphore de la maison)
export const PROCESS = [
  {
    n: '01',
    title: 'Le Terrain',
    body: "Faire le point sur votre situation actuelle : ce qui pèse, ce qui manque, ce qui doit changer.",
  },
  {
    n: '02',
    title: 'Les Fondations',
    body: "Mieux se connaître pour construire sur du solide : valeurs, besoins, fonctionnement.",
  },
  {
    n: '03',
    title: 'La Structure',
    body: "Définir une direction professionnelle claire et cohérente.",
  },
  {
    n: '04',
    title: 'Le Mouvement',
    body: "Décider, lever les blocages et passer à l'action, étape après étape.",
  },
  {
    n: '05',
    title: 'La Consolidation',
    body: "Maintenir la transformation dans la durée pour qu'elle tienne.",
  },
];

export const FAQ = [
  {
    q: "À qui s'adresse l'accompagnement ?",
    a: "Aux professionnels et cadres qui ressentent un manque de clarté, de sens ou d'alignement dans leur vie professionnelle.",
  },
  {
    q: "En quoi consiste la méthode ?",
    a: "Une méthode en 5 étapes pour mieux se connaître, clarifier ses priorités, lever ses blocages et construire une trajectoire professionnelle alignée.",
  },
  {
    q: "Est-ce un bilan de compétences ?",
    a: "C'est bien plus qu'un bilan de compétences. La méthode travaille aussi sur vos valeurs, votre fonctionnement, vos motivations, vos aspirations et vos blocages.",
  },
  {
    q: "Faut-il quitter son travail ?",
    a: "Non. L'objectif est de trouver la décision la plus juste : évolution interne, réorientation ou nouveau projet.",
  },
  {
    q: "Comment se passe le premier rendez-vous ?",
    a: "Un entretien de 45 minutes, offert et sans engagement, pour faire le point sur votre situation et déterminer si l'accompagnement est adapté.",
  },
];
